module.exports = __webpack_public_path__ + "img/BLZ.eb254eca.svg";